@if (!disabled && link) {
<div [routerLink]="link">
  <ng-container *ngTemplateOutlet="a"></ng-container>
</div>
} @else {
<ng-container *ngTemplateOutlet="a"></ng-container>
}
<ng-template #a>
  <div
    class="slide-summary"
    [matTooltip]="'SINGLE_TRAINING.SLIDE_TOOLTIP' | translate"
    [matTooltipDisabled]="!disabled"
    matTooltipClass="primary-tooltip"
    [ngClass]="{disabled: disabled}"
    [class.visited]="visited">
    <div class="slide-summary-icon">
      <img [src]="iconPath" alt="Slide" />
    </div>
    <div class="slide-summary-title-wrapper">
      <div class="slide-summary-title">{{ title }}</div>
      @if (duration) {
      <div class="d-none d-sm-flex slide-summary-duration me-4">
        <mat-icon svgIcon="clock_v2"></mat-icon>
        <span class="duration-width">{{ duration }}</span>
      </div>
      }
    </div>
    @if (!visited) {
    <i-feather name="chevron-right"></i-feather>
    } @else {
    <img class="check-icon" src="assets/img/troodi/check_v2.svg" alt="icon" />
    }
  </div>
</ng-template>
